import {animate, state, style, transition, trigger} from '@angular/animations';
import {AfterViewInit, Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss']
})
export class CounterComponent implements OnInit, AfterViewInit {
  constructor(
    @Inject(PLATFORM_ID) private platformId,
  ) {
  }

  @ViewChild('counterElement') counterElement!: ElementRef;
  count: number = 0;
  @Input() startCount: number = 0;
  @Input() endCount: number = 1000;


  ngOnInit(): void {
    this.animateCount();
  }

  ngAfterViewInit(): void {
    this.checkVisibility();
  }

  checkVisibility(): void {
    if (isPlatformBrowser(this.platformId)) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.animateCount();
            } else {
              this.count = this.startCount;
            }
          });
        },
        {threshold: [0.5]}
      );

      observer.observe(this.counterElement.nativeElement);
    }
  }

  animateCount(): void {
    this.count = this.startCount;
    const duration = 2000; // 2 seconds
    const increment = (this.endCount - this.startCount) / duration;
    let startTime = Date.now();

    const intervalId = setInterval(() => {
      const timePassed = Date.now() - startTime;
      if (timePassed >= duration) {
        clearInterval(intervalId);
        this.count = this.endCount;
      } else {
        this.count = Math.round(this.startCount + increment * timePassed);
      }
    }, 50);
  }
}
